import type { FaireProductEntity } from "../../entity_types/product";

export const p_4kl0c5dwr4: FaireProductEntity = {
  token: "p_4kl0c5dwr4",
  type: "product",
  name: "Boundless Belize 100% Cacao - Organic Ceremonial Chocolate",
  brandToken: "b_djuc44eyt2",
  brandName: "Ora Cacao",
  imageUrl:
    "https://cdn.faire.com/fastly/ba0830b56d50c8458a2cd2c9baf2474a94d3ec3cc7e2163c077ca4feb6b6599f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/69abd7b6b20b5ee5f1d6cb7ba109b955d37e4ba9e28bb6f7e45469a8c406d98a.png",
    "https://cdn.faire.com/fastly/1f747abb235ee5e0715737b342f0dbf39252528a60e39453e42c7a02edc40e90.png",
    "https://cdn.faire.com/fastly/064b94bd5eebe080422e6cf3161eab913ac1ddb843f17e65b665820a859e8621.png",
    "https://cdn.faire.com/fastly/1abe7c5b801d07a78a9c7d3e5a6221efe0379affb4c142ac9735ccbedc41d313.png",
    "https://cdn.faire.com/fastly/989e41768e529cd8dfe09bce992c0f80069a871b4fcd120e730f9971ae729328.jpeg",
    "https://cdn.faire.com/fastly/60ef7c12fafb863246699c218328889af5fdc82a5030d54a5be31fe090c0ea23.jpeg",
    "https://cdn.faire.com/fastly/2b879e097bdf799b5ebdffd4a088b3ce16bdd2c4a98070daddb152cbf828e95a.jpeg",
  ],
  priceDollars: 18.3,
  description:
    "Dive deep into personal inquiry with this magical drinking chocolate grown amidst rainforests that cover ancient Mayan pyramids. Peel back the layers of your boundless self with meditation, ritual and self inquiry as you drink this pure ceremonial cacao coming straight from three hundred indigenous Q'eqchi' and Mopan Maya families in southern Belize.\n\nThis ceremonial cacao comes from 300 small (1-5 acre) organic family farms in the foothills of southern Belize. 75% of our farming families are indigenous Maya, and they grow their pure raw cacao with deep respect and understanding of the local ecology. We've invested in a permaculture demonstration farm here to pioneer innovative agroforestry techniques, advance cacao cultivation in the region, and propagate heirloom seedlings.\n\n• Makes a great coffee replacement!\n• For dark chocolate lovers.\n• Lab tested for heavy metals safety.\n• High flavanol / flavonoid.",
  tags: [],
  msrpDollars: 30.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T01:35:38.534Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
